import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";


export const getCategoriasFinanzas = async () => {
    const result = await PrivateInterceptor(`Base/Global/CategoriasFinanzas`, 'GET');
    return result;

}

export const getInventarioCategoria = async (dates, IdCategoriaFinanzas) =>{
    const result = await PrivateInterceptor(`Base/Global/CategoriasFinanzas/InventarioCategoria`, 'POST', {FechaInicio :dates[0], FechaFinal: dates[1], IdCategoriaFinanzas: IdCategoriaFinanzas} );
    return result;

}

export const getInfoCategoria = async (IdCategoriaFinanzas) => {

    const result = await PrivateInterceptor(`Base/Global/CategoriasFinanzas/${IdCategoriaFinanzas}`, 'GET');
    return result;

}